<script>
  import clsx from "clsx";
  import Content from "./Content.svelte";
  import tippy from "sveltejs-tippy";

  let className = null;
  export { className as class };
  export let href = null;
  export let inline = true;
  export let disabled = false;
  export let type = "button";
  export let eventOnClick = null;
  export let target = null;
  export let rel = null;
  export let tooltip;
  export let main = false;
  export const minor = true;
  export let ghost = false;
  export let link = false;
  export let badge = false;

  // can be "main", "minor", "ghost" or "link"
  let appearance = "minor";
  if (main) {
    appearance = "main";
  } else if (ghost) {
    appearance = "ghost";
  } else if (link) {
    appearance = "link";
  }

  // If ghost is on dark background, set this to true
  export let dark = false;

  const BEM = clsx(className, "not-prose", (badge || appearance == "ghost") && "relative", "btn", `btn--${appearance}`, {
    "btn--dark": dark,
    "btn--inline": inline,
  });
</script>

{#if tooltip}
  {#if href}
    <a href={disabled ? null : href} class={BEM} class:disabled {target} {rel} x-data="linkicon" aria-label={tooltip} use:tippy={{ content: tooltip }}>
      <Content {appearance} {badge} {dark} icon>
        <slot />
      </Content>
    </a>
  {:else if eventOnClick}
    <button
      type="button"
      class={BEM}
      class:disabled
      on:click={() => {
        if (disabled) {
          return;
        }
        window.dispatchEvent(new CustomEvent(eventOnClick));
      }}
      aria-label={tooltip}
      use:tippy={{ content: tooltip }}
    >
      <Content {appearance} {dark} {badge}>
        <slot />
      </Content>
    </button>
  {:else}
    <button {type} class={BEM} class:disabled on:click aria-label={tooltip} use:tippy={{ content: tooltip }}>
      <Content {appearance} {dark} {badge}>
        <slot />
      </Content>
    </button>
  {/if}
{:else if href}
  <a href={disabled ? null : href} class={BEM} class:disabled {target} {rel} x-data="linkicon">
    <Content {appearance} {dark} {badge} icon>
      <slot />
    </Content>
  </a>
{:else if eventOnClick}
  <button
    type="button"
    class={BEM}
    class:disabled
    on:click={() => {
      if (disabled) {
        return;
      }
      window.dispatchEvent(new CustomEvent(eventOnClick));
    }}
  >
    <Content {appearance} {dark} {badge}>
      <slot />
    </Content>
  </button>
{:else}
  <button {type} class={BEM} class:disabled on:click>
    <Content {appearance} {dark} {badge}>
      <slot />
    </Content>
  </button>
{/if}
